import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueCurrencyInput from "vue-currency-input";
import VueTheMask from "vue-the-mask";
import { name, version } from "../package.json";

if (!Intl.NumberFormat.prototype.formatToParts) {
  Intl.NumberFormat = require("intl").NumberFormat;
  require("intl/locale-data/jsonp/pl-PL");
}

Vue.use(VueTheMask);
Vue.use(VueCurrencyInput, {
  globalOptions: { currency: "PLN", locale: "pl-PL", allowNegative: false },
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");

console.log(`${name} v${version} ${process.env.NODE_ENV}`);
